// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, no-else-return */
 
 
/* eslint-disable react/jsx-newline */
 
 
 
/* eslint-disable no-nested-ternary */
 
import React from 'react';
import {
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';
import { TextCell } from 'app/components/shared/table';
import { useIntl } from 'react-intl';
import BoltIcon from '@mui/icons-material/Bolt';

const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
    totalsFooter: {
      position: 'sticky',
      bottom: 0,
      zIndex: 2,
      '& td': {
        backgroundColor: '#fff',
        borderTop: '2px solid #e0e0e0',
      },
    },
  })
);

const BothTranscTable = ({ transactions, isLoading, convertToLocalTime, displayedTotalAmount, displayedTotalCredits, displayedTotalDebits, transactionsTotalCredits, transactionsTotalDebits }) => {
  const intl = useIntl();
  const classes = useStyles();
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  const formatTotal = (value) => {
    const num = Math.abs(parseFloat(value) || 0);
    return num.toFixed(2);
  };

  /*React.useEffect(() => {
    // Inject print CSS to only show the table when printing
    const style = document.createElement('style');
    style.type = 'text/css';
    style.id = 'print-both-transc-table-style';
    style.innerHTML = `
      @media print {
        body * { visibility: hidden !important; }
        #printable-both-transc-table, #printable-both-transc-table * { visibility: visible !important; }
        #printable-both-transc-table { position: absolute !important; left: 0; top: 0; width: 100vw; background: white; z-index: 9999; overflow: visible !important; }
        button, .MuiButtonBase-root { display: none !important; }
        .MuiTable-root, .MuiTableHead-root, .MuiTableBody-root, .MuiTableRow-root, .MuiTableCell-root {
          overflow: visible !important;
          white-space: normal !important;
        }
        tr, td, th {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      const existing = document.getElementById('print-both-transc-table-style');
      if (existing) existing.remove();
    };
  }, []);*/

  // Helper to get description
  const getDescription = (row) => {
    const circleStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '17px',
      height: '17px',
      borderRadius: '10px 0px 10px 0px',

      fontSize: '22px',
      fontWeight: 'bold',
      marginRight: '5px',
      lineHeight: '1',
      textAlign: 'center',
      verticalAlign: 'middle'
    };
    const symbolTextStyle = {
      display: 'block',
      margin: '5px',
      fontSize:"19px"
    };
    switch (row.transaction_type) {
      case 'charging':
        return (
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center" }}>
        <span style={symbolTextStyle}>+</span>
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'chargingOperation' })}
            </span>
          </div>
        );
      case 'ticketing':
        return (
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center"  }}>
            <span style={symbolTextStyle}>-</span>
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'ticketingOperation' })}
            </span>
          </div>
        );
      case 'reversal':
        return (
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center"  }}>
            <span style={symbolTextStyle}>-</span>
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'reversalOperation' })}
            </span>
          </div>
        );
      case 'fees_deducted_on_charging':
        return (
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center"  }}>
            <span style={symbolTextStyle}>-</span>
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'feesDeductedOnCharging' })}
            </span>
          </div>
        );
      case 'vat_deducted_on_charging':
        return (
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center"  }}>
            <span style={symbolTextStyle}>-</span>
            <span style={{ color: "#666"}}>
              {intl.formatMessage({ id: 'vatDeductedOnCharging' })}
            </span>
          </div>
        );
      case 'initial_balance':
        return (
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center" }}>
            
              <span style={symbolTextStyle}>+</span>
            
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'initBalanceOperation' })}
            </span>
          </div>
        );
      case 'transfer_from_wallet':
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
            <span style={symbolTextStyle}>-</span>
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'transferFromWalletOperation', defaultMessage: 'Transfer From Wallet' })}
            </span>
          </div>
        );
      case 'transfer_to_wallet':
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
            <span style={symbolTextStyle}>+</span>
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'transferToWalletOperation', defaultMessage: 'Transfer To Wallet' })}
            </span>
          </div>
        );
      case 'migration':
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
            <span style={symbolTextStyle}>+</span>
            <span style={{ color: "#666" }}>
              {intl.formatMessage({ id: 'migrationOperation', defaultMessage: 'Migration' })}
            </span>
          </div>
        );
      default:
        return (
          <div style={{ display: 'flex', alignItems: 'center',justifyContent:"center"  }}>
            <span style={{ ...circleStyle, backgroundColor: '#666', color: 'white' }}>-</span>
            <span style={{ color: "#666" }}>-</span>
          </div>
        );
    }
  };

  // Helper to get channel
  const getChannel = (row) => {
    if (row.transaction_type === 'ticketing') {
      return currentLanguageCode === 'en-us'
        ? row.transaction_details.axis_en_name
        : row.transaction_details.axis_ar_name;
    } else if (row.transaction_type === 'charging' || row.transaction_type === 'reversal' || row.transaction_type === 'fees_deducted_on_charging' || row.transaction_type === 'vat_deducted_on_charging' || row.transaction_type === 'initial_balance' || row.transaction_type === 'transfer_from_wallet' || row.transaction_type === 'transfer_to_wallet' || row.transaction_type === 'migration') {
      return row.transaction_details.DEVICE_SERIAL_NUMBER || '-';
    }
    return '-';
  };

  // Helper to get debit value
  const getDebit = (row) => row.debit ? Math.abs(Number(row.transaction_amount)) : '-';

  // Helper to get credit value
  const getCredit = (row) => row.credit ? Math.abs(Number(row.transaction_amount)) : '-';

  // Helper to get transaction number
  const getTn = (row) => {
    if (row.transaction_type === 'ticketing') {
      return row.transaction_details.ticket_serial;
    } else if (row.transaction_type === 'charging' || row.transaction_type === 'reversal' || row.transaction_type === 'fees_deducted_on_charging' || row.transaction_type === 'vat_deducted_on_charging' || row.transaction_type === 'initial_balance' || row.transaction_type === 'transfer_from_wallet' || row.transaction_type === 'transfer_to_wallet' || row.transaction_type === 'migration') {
      return row.transaction_details.MERCHANT_REF || row.id;
    }
    return row.id;
  };

  // Use the result array directly, reverse for newest first
  //const sortedTransactions = [...transactions].reverse();

  return (
  
    <div>
      {/*<button
        onClick={() => {
          window.print();
        }}
        style={{
          margin: '10px 0',
          padding: '6px 16px',
          background: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'Cairo',
        }}
      >
        {intl.formatMessage({ id: 'print', defaultMessage: 'Print' })}
      </button>*/}
      <div id="printable-both-transc-table">
        <Table className={classes.table} size="small" aria-label="both transactions table">
      <TableHead style={{ border: "0" }}>
        <TableRow style={{ border: "0" }}>
          <TableCell align="center">{intl.formatMessage({ id: 'ticketDate' })}</TableCell>
          <TableCell align="center">{intl.formatMessage({ id: 'transID' })}</TableCell>
          <TableCell align="center">{intl.formatMessage({ id: 'description' })}</TableCell>
          <TableCell align="center">{intl.formatMessage({ id: 'channel' })}</TableCell>
          <TableCell align="center">{intl.formatMessage({ id: 'debit' })}</TableCell>
          <TableCell align="center">{intl.formatMessage({ id: 'credit' })}</TableCell>
          <TableCell align="center">{intl.formatMessage({ id: 'balance' })}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? (
          <tr>
            <td colSpan={12} style={{ textAlign: "center", padding: "15px" }}>
              {intl.formatMessage({ id: 'loading' })}
            </td>
          </tr>
        ) : transactions?.length > 0 ? (
          transactions.map((r, idx) => (
            <TableRow key={r.id || idx} className={classes.row}>
              <TextCell label={convertToLocalTime(r.transaction_time)} align="center" style={{ fontFamily: 'Cairo', fontWeight: 600 }} />
              <TextCell label={getTn(r)} align="center" style={{ fontFamily: 'Cairo', fontWeight: 600 }} />
              <TextCell label={getDescription(r)} align="center" style={{ fontFamily: 'Cairo', fontWeight: 600 }} />
              <TextCell label={getChannel(r)} align="center" style={{ fontFamily: 'Cairo', fontWeight: 600 }} />
              <TextCell label={getDebit(r)} align="center" style={{ fontFamily: 'Cairo', fontWeight: 600 }} />
              <TextCell label={getCredit(r)} align="center" style={{ fontFamily: 'Cairo', fontWeight: 600 }} />
              <TextCell label={r.new_card_balance !== undefined && r.new_card_balance !== null ? Number(r.new_card_balance).toFixed(3) : '-'} align="center" style={{ fontFamily: 'Cairo', fontWeight: 600 }} />
            </TableRow>
          ))
        ) : (
          <tr>
            <td colSpan={12} style={{ textAlign: "center", padding: "15px" }}>
              {intl.formatMessage({ id: 'NoDateAvailable' })}
            </td>
          </tr>
        )}

   
      </TableBody>
      {transactions?.length > 0 && (
        <TableFooter className={classes.totalsFooter}>
          <TableRow>
            <TableCell colSpan={4} align="right" style={{ fontFamily: 'Cairo', fontWeight: 700 }}>
              {intl.formatMessage({ id: 'accountStatementTotalsLabel' })}
            </TableCell>
            <TableCell align="center" style={{ fontFamily: 'Cairo', fontWeight: 700 }}>
              {formatTotal(transactionsTotalDebits)}
            </TableCell>
            <TableCell align="center" style={{ fontFamily: 'Cairo', fontWeight: 700 }}>
              {formatTotal(transactionsTotalCredits)}
            </TableCell>
            <TableCell />
          </TableRow>
        </TableFooter>
      )}
    </Table>
      </div>
    
    </div>
  
  );
};

export { BothTranscTable };